"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LayeredTableHeader;
var _react = _interopRequireDefault(require("react"));
var _carbonComponentsReact = require("carbon-components-react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function LayeredTableHeader(_ref) {
  let {
    headerRows
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, headerRows.map((row, i) => {
    let {
      headers,
      ...rest
    } = row;
    return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TableRow, _extends({
      key: i
    }, rest), headers.map((header, i) => {
      let {
        name,
        ...passThrogh
      } = header;
      return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TableHeader, _extends({
        key: i
      }, passThrogh), name);
    }));
  }));
}